"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseSettlementDocumentType = exports.calculateBorrowerClosingCostTotalsByGroup = exports.isBorrowerPaidAtClosingFee = exports.CLOSING_COST_GROUP_BY_FEE_TYPE = exports.ClosingCostGroup = exports.IntentToProceedStatus = void 0;
const assertUtils_1 = require("../assertUtils");
const homePurchaseSlider_1 = require("./homePurchaseSlider");
const homePurchaseTerms_1 = require("./homePurchaseTerms");
/**
 * Whether the borrower has confirmed intent to proceed on a purchase settlement. Persisted on
 * purchase_settlement.intent_to_proceed_obtained and returned by /purchase_settlement/record_intent_to_proceed,
 * so it is shared rather than backend-only. String values match the stored column values.
 */
var IntentToProceedStatus;
(function (IntentToProceedStatus) {
    IntentToProceedStatus["AWAITING"] = "AWAITING";
    IntentToProceedStatus["OBTAINED"] = "OBTAINED";
})(IntentToProceedStatus || (exports.IntentToProceedStatus = IntentToProceedStatus = {}));
/** Presentation buckets for the estimated-closing-costs page, in display order. */
/** @TranslateToPython @TranslateToEnum */
var ClosingCostGroup;
(function (ClosingCostGroup) {
    ClosingCostGroup["financial"] = "financial";
    ClosingCostGroup["lenderFees"] = "lenderFees";
    ClosingCostGroup["prorations"] = "prorations";
    ClosingCostGroup["titleAndEscrow"] = "titleAndEscrow";
    ClosingCostGroup["governmentTaxesAndFees"] = "governmentTaxesAndFees";
    ClosingCostGroup["payoffs"] = "payoffs";
    ClosingCostGroup["prepaids"] = "prepaids";
    ClosingCostGroup["inspectionWarrantyHoa"] = "inspectionWarrantyHoa";
    ClosingCostGroup["miscellaneous"] = "miscellaneous";
    ClosingCostGroup["deposits"] = "deposits";
    ClosingCostGroup["credits"] = "credits";
})(ClosingCostGroup || (exports.ClosingCostGroup = ClosingCostGroup = {}));
/** Default closing-cost bucket for every fee type. */
exports.CLOSING_COST_GROUP_BY_FEE_TYPE = {
    [homePurchaseTerms_1.HomePurchaseFeeType.estimatedPreHomeNonLenderClosingCost]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.personalProperty]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.existingLoansAssumed]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.financialSellerCredit]: ClosingCostGroup.credits,
    [homePurchaseTerms_1.HomePurchaseFeeType.baseSellerCredit]: ClosingCostGroup.credits,
    [homePurchaseTerms_1.HomePurchaseFeeType.excessSellerCredit]: ClosingCostGroup.credits,
    [homePurchaseTerms_1.HomePurchaseFeeType.excessDeposit]: ClosingCostGroup.deposits,
    [homePurchaseTerms_1.HomePurchaseFeeType.propertyTaxProration]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.schoolTaxProration]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.hoaDuesProration]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.prorationsSellerCredit]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.lenderFee]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.prepaidInterest]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.appraisal]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.creditReport]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.floodDetermination]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.floodMonitoring]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.taxMonitoring]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.taxStatusResearch]: ClosingCostGroup.lenderFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.impoundsHomeownersInsurance]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.impoundsMortgageInsurance]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.impoundsCityTownTaxes]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.impoundsCountyTaxes]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.impoundsSchoolTaxes]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.aggregateAdjustment]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.ownersTitleInsurance]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.loanPolicyTitleInsurance]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.titleSearchFee]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.insuranceBinder]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.escrowFee]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.notary]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.signing]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.buyerAgentCommission]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.sellerAgentCommission]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.recordingDeedFee]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.recordingMortgageFee]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.recordingOther]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.transferTaxes]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.pestInspection]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.payoffPrincipalBalance]: ClosingCostGroup.payoffs,
    [homePurchaseTerms_1.HomePurchaseFeeType.payoffInterest]: ClosingCostGroup.payoffs,
    [homePurchaseTerms_1.HomePurchaseFeeType.payoffAdditionalFees]: ClosingCostGroup.payoffs,
    [homePurchaseTerms_1.HomePurchaseFeeType.survey]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.homeownersInsurancePremium]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.homeInspection]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.homeWarranty]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.miscellaneousHoaDues]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.transferFeeToManagementCo]: ClosingCostGroup.inspectionWarrantyHoa,
    [homePurchaseTerms_1.HomePurchaseFeeType.assessments]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.assessmentsSchoolTaxes]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.assessmentsCityTownTaxes]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.assessmentsCountyPropertyTaxes]: ClosingCostGroup.governmentTaxesAndFees,
    [homePurchaseTerms_1.HomePurchaseFeeType.buyerAttorney]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.sellerAttorney]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.custom]: ClosingCostGroup.miscellaneous,
    [homePurchaseTerms_1.HomePurchaseFeeType.propertyInsurance]: ClosingCostGroup.prorations,
    [homePurchaseTerms_1.HomePurchaseFeeType.titleLoanClosingFee]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.titleSettlementOrClosingFee]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.titleFilingFee]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.cplFees]: ClosingCostGroup.titleAndEscrow,
    [homePurchaseTerms_1.HomePurchaseFeeType.depositOther]: ClosingCostGroup.deposits,
};
/** True for a fee the borrower pays out of pocket at closing, as opposed to seller-paid, lender-absorbed, or already-paid-before-closing. */
const isBorrowerPaidAtClosingFee = (fee) => {
    const financingOptionType = fee.financingOption.financingOptionType;
    switch (financingOptionType) {
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.borrowerPaidAtClosing:
            return true;
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.borrowerPaidBeforeClosing:
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.sellerPaidAtClosing:
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.sellerPaidBeforeClosing:
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.lenderPaidBeforeClosingAbsorbed:
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.lenderPaidAtClosingAbsorbed:
        case homePurchaseTerms_1.HomePurchaseFeeFinancingOptionType.lenderPaidAtClosingFinancedForBorrower:
            return false;
        default:
            return (0, assertUtils_1.assertNever)(financingOptionType, `Unhandled purchase fee financing option ${financingOptionType}`);
    }
};
exports.isBorrowerPaidAtClosingFee = isBorrowerPaidAtClosingFee;
/**
 * Dollars the borrower owes in each presentation bucket, summed from the borrower-paid-at-closing fees.
 * Empty buckets are omitted. Summed in integer cents since aven_types can't use the backend's mathCore addon.
 */
// TODO: move to the backend so the cent arithmetic uses mathCore (D256) instead of integer cents.
const calculateBorrowerClosingCostTotalsByGroup = (feeTerms) => {
    const totalsByGroupInCents = {};
    feeTerms.filter(exports.isBorrowerPaidAtClosingFee).forEach((fee) => {
        const group = exports.CLOSING_COST_GROUP_BY_FEE_TYPE[fee.feeType];
        const feeAmountInCents = Math.round((0, homePurchaseSlider_1.getCalculatedAmountDollars)(fee.feeAmount) * 100);
        totalsByGroupInCents[group] = (totalsByGroupInCents[group] ?? 0) + feeAmountInCents;
    });
    return Object.fromEntries(Object.entries(totalsByGroupInCents).map(([group, cents]) => [group, cents / 100]));
};
exports.calculateBorrowerClosingCostTotalsByGroup = calculateBorrowerClosingCostTotalsByGroup;
/**
 * Documents attached to a purchase settlement. Shared rather than backend-only because the borrower
 * upload endpoint (/purchase_settlement/borrower_upload_document) takes this as a request field.
 * Stored as varchar per the "Specific TypeScript Types, Generic SQL Types" convention, so deprecated
 * values are never removed.
 */
var PurchaseSettlementDocumentType;
(function (PurchaseSettlementDocumentType) {
    // Uploaded (borrower / settlement agent / third party)
    PurchaseSettlementDocumentType["purchaseContract"] = "purchaseContract";
    PurchaseSettlementDocumentType["addendum"] = "addendum";
    PurchaseSettlementDocumentType["counteroffer"] = "counteroffer";
    PurchaseSettlementDocumentType["earnestMoneyDepositReceipt"] = "earnestMoneyDepositReceipt";
    PurchaseSettlementDocumentType["initialSettlementStatement"] = "initialSettlementStatement";
    PurchaseSettlementDocumentType["finalSettlementStatement"] = "finalSettlementStatement";
    PurchaseSettlementDocumentType["titleCommitment"] = "titleCommitment";
    PurchaseSettlementDocumentType["closingProtectionLetter"] = "closingProtectionLetter";
    PurchaseSettlementDocumentType["platMap"] = "platMap";
    PurchaseSettlementDocumentType["propertyTaxCertificate"] = "propertyTaxCertificate";
    PurchaseSettlementDocumentType["titleEAndO"] = "titleEAndO";
    PurchaseSettlementDocumentType["wiringInstructions"] = "wiringInstructions";
    PurchaseSettlementDocumentType["proposedDeedVestingInstructions"] = "proposedDeedVestingInstructions";
    PurchaseSettlementDocumentType["realEstateAgentContactInfo"] = "realEstateAgentContactInfo";
    PurchaseSettlementDocumentType["entityDocumentation"] = "entityDocumentation";
    PurchaseSettlementDocumentType["certificateOfGoodStanding"] = "certificateOfGoodStanding";
    PurchaseSettlementDocumentType["trustAgreement"] = "trustAgreement";
    PurchaseSettlementDocumentType["operatingAgreement"] = "operatingAgreement";
    PurchaseSettlementDocumentType["hoaDetails"] = "hoaDetails";
    PurchaseSettlementDocumentType["signedClosingPackage"] = "signedClosingPackage";
    // Generated (by Aven)
    PurchaseSettlementDocumentType["titleSettlementOrderEmail"] = "titleSettlementOrderEmail";
    PurchaseSettlementDocumentType["avenSettlementStatement"] = "avenSettlementStatement";
    PurchaseSettlementDocumentType["balancingConfirmation"] = "balancingConfirmation";
    PurchaseSettlementDocumentType["closingInstructions"] = "closingInstructions";
    PurchaseSettlementDocumentType["closingPackage"] = "closingPackage";
    PurchaseSettlementDocumentType["shadowClosingPackage"] = "shadowClosingPackage";
})(PurchaseSettlementDocumentType || (exports.PurchaseSettlementDocumentType = PurchaseSettlementDocumentType = {}));
